import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 工單需求彙總轉倉 list（固定 sourceType=WORK_ORDER、sourceId=null）。
 * 勿在 filters 切換 sourceType／sourceId。
 */
export async function fetchWorkOrderStockTransferList(listQuery) {
  const { data: raw } = await request.get('/mom/work-order/stock-transfer', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
